import { UserPlus, Users, MessageSquare, Calendar } from "lucide-react";

const STEPS = [
  {
    icon: UserPlus,
    label: "01 · Sign up",
    title: "Add your college & batch",
    body: "Only Ayurveda scholars — you're in the moment you share your BAMS college, university and batch year.",
  },
  {
    icon: Users,
    label: "02 · Reconnect",
    title: "Find your classmates & gurus",
    body: "Auto-joined into your college group and batch group. Follow senior Vaidyas from the curated Guru Directory.",
  },
  {
    icon: MessageSquare,
    label: "03 · Talk",
    title: "Post, comment, chat",
    body: "Share cases from clinic, discuss Samhita passages, DM a colleague, or drop a doubt into a specialty feed.",
  },
  {
    icon: Calendar,
    label: "04 · Meet up",
    title: "Journal clubs, CMEs, opportunities",
    body: "RSVP meet-ups across cities, browse the BAMS/MD/MS job board — all inside the community.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="max-w-7xl mx-auto px-6 py-20 border-t border-[color:var(--ayur-border)]">
      <div className="text-center max-w-2xl mx-auto">
        <div className="label-eyebrow">The 60-second explainer</div>
        <h2 className="font-serif-display text-3xl sm:text-4xl mt-3 text-[color:var(--ayur-emerald)]">
          What is VaidGram?
        </h2>
        <p className="mt-4 text-[color:var(--ayur-ink-2)]">
          A private social network built only for BAMS, MD & MS Ayurveda scholars.
          Verified peers. Warm conversations. Zero noise.
        </p>
      </div>

      <div className="mt-12 grid md:grid-cols-4 gap-6">
        {STEPS.map((s, i) => (
          <div
            key={i}
            className="paper-card p-6 relative overflow-hidden animate-fade-up"
            style={{ animationDelay: `${i * 100}ms` }}
          >
            <div className="w-11 h-11 rounded-full bg-[color:var(--ayur-emerald)]/10 flex items-center justify-center mb-4">
              <s.icon className="w-5 h-5 text-[color:var(--ayur-emerald)]" />
            </div>
            <div className="label-eyebrow">{s.label}</div>
            <h3 className="font-serif-display text-lg mt-2 text-[color:var(--ayur-ink)]">{s.title}</h3>
            <p className="mt-2 text-sm text-[color:var(--ayur-ink-2)] leading-relaxed">{s.body}</p>
            <div className="absolute -bottom-4 -right-4 text-8xl font-serif-display font-bold text-[color:var(--ayur-cream-2)] select-none">
              {i + 1}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-16 grid md:grid-cols-3 gap-6">
        {[
          { stat: "10+", label: "Curated Vaidyas & researchers already inside" },
          { stat: "12", label: "Specialty feeds — Panchakarma, Shalya, Rasashastra & more" },
          { stat: "1:1", label: "Private chat, meet-ups, jobs — all in one place" },
        ].map((s, i) => (
          <div key={i} className="paper-card p-6 text-center">
            <div className="font-serif-display text-4xl text-[color:var(--ayur-terracotta)]">{s.stat}</div>
            <div className="text-sm text-[color:var(--ayur-ink-2)] mt-1">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
